export const translations = {
  tr: {
    app_name: "Dinamik Performans",
    company: "Dinamik Performans",
    nav: {
      dashboard: "Gösterge Paneli",
      orders: "Siparişler",
      production: "Üretim / İmalat",
      inventory: "Depo / Stok",
      products: "Ürünler",
      customers: "Müşteriler",
      accounting: "Muhasebe / Cari",
      reports: "Raporlar",
    },
    common: {
      new: "Yeni",
      add: "Ekle",
      edit: "Düzenle",
      delete: "Sil",
      save: "Kaydet",
      cancel: "İptal",
      search: "Ara...",
      actions: "İşlemler",
      total: "Toplam",
      status: "Durum",
      date: "Tarih",
      amount: "Tutar",
      quantity: "Miktar",
      unit_price: "Birim Fiyat",
      loading: "Yükleniyor...",
      no_data: "Kayıt bulunamadı",
      confirm_delete: "Silmek istediğinize emin misiniz?",
      close: "Kapat",
      detail: "Detay",
      seed: "Demo Veri Yükle",
    },
    order_status: {
      taslak: "Taslak",
      onaylandi: "Onaylandı",
      depoda: "Depoda",
      uretimde: "Üretimde",
      tamamlandi: "Tamamlandı",
      iptal: "İptal",
    },
    prod_status: {
      bekliyor: "Bekliyor",
      uretimde: "Üretimde",
      kalite: "Kalite Kontrol",
      tamamlandi: "Tamamlandı",
    },
  },
  en: {
    app_name: "Dinamik Performans",
    company: "Dinamik Performans",
    nav: {
      dashboard: "Dashboard",
      orders: "Orders",
      production: "Production",
      inventory: "Warehouse / Stock",
      products: "Products",
      customers: "Customers",
      accounting: "Accounting",
      reports: "Reports",
    },
    common: {
      new: "New",
      add: "Add",
      edit: "Edit",
      delete: "Delete",
      save: "Save",
      cancel: "Cancel",
      search: "Search...",
      actions: "Actions",
      total: "Total",
      status: "Status",
      date: "Date",
      amount: "Amount",
      quantity: "Qty",
      unit_price: "Unit Price",
      loading: "Loading...",
      no_data: "No records found",
      confirm_delete: "Are you sure you want to delete?",
      close: "Close",
      detail: "Detail",
      seed: "Load Demo Data",
    },
    order_status: {
      taslak: "Draft",
      onaylandi: "Approved",
      depoda: "In Warehouse",
      uretimde: "In Production",
      tamamlandi: "Completed",
      iptal: "Cancelled",
    },
    prod_status: {
      bekliyor: "Pending",
      uretimde: "In Production",
      kalite: "Quality Check",
      tamamlandi: "Completed",
    },
  },
};

export const CURRENCIES = {
  TRY: { symbol: "₺", locale: "tr-TR", code: "TRY" },
  USD: { symbol: "$", locale: "en-US", code: "USD" },
  EUR: { symbol: "€", locale: "de-DE", code: "EUR" },
};
